<template>
    <div class="view-container">
        <div class="container view">
            <div class="add-container">
                <span class="container-title">Send SMS</span>
                <div class="col-wrapper">
                    <div class="col">
                        <div class="primary-input-container weekdays-from">
                            <p class="pimary-input-title">ANI</p>
                            <div class="primary-select-wrapper">
                                <select v-model="company" name="company" :class="{'input': true, 'is-danger': errors.has('company')}">
                                    <option v-for="(cmp, idx) in company_list" :key="idx" :value="cmp.did">{{cmp.did}}</option>
                                </select>
                                <img src="/img/Down.b9194302.svg" alt="" class="icon-down">

                            </div>
                            <div class="help is-danger" v-if="errors.has('company')">{{ errors.first('company') }}</div>
                        </div>

                        <el-radio-group v-model="checked">
                            <el-radio label="Bulk"></el-radio>
                            <el-radio label="Import"></el-radio>
                        </el-radio-group>

                        <div v-if="checked === 'Import'" class="primary-input-container mt-3" style="margin-bottom: 15px">
                            <div>
                                <p class="pimary-input-title">Upload CSV Number List</p>
                                <input type="file" id="number_list" v-on:change="onFileChange">
                            </div>
                        </div>

                        <div v-else-if="checked === 'Bulk'" class="primary-input-container text-area">
                            <p class="pimary-input-title">Numbers</p>
                            <div class="text-area-container">
                                <textarea v-model="bulk_text" v-if="uploadNumbers.length == 0" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('bulk_text')}" name="bulk_text" placeholder="Enter numbers" cols="30" rows="10"></textarea>
                                <textarea v-model="bulk_text" v-else :class="{'input': true, 'is-danger': errors.has('bulk_text')}" name="bulk_text" placeholder="Enter numbers" cols="30" rows="10"></textarea>
                            </div>
                            <div class="help is-danger" v-if="errors.has('bulk_text')">{{ errors.first('bulk_text') }}</div>
                        </div>
                        <div v-else class="primary-input-container field input" style="position:relative;">
                            <p class="pimary-input-title"> DNIS</p>
                            <input list="recipient" name="recipient" class="pimary-input" v-model="dnis" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('recipient')}">
                            <datalist id="recipient">
                                <option v-for="(dn, idx) in dnis_list" :key="idx" :value="dn.phone_number" />
                            </datalist>
                            <img src="/img/Down.b9194302.svg" alt="" class="icon-down datalist-img bg-white">
                            <div class="help is-danger" v-if="errors.has('recipient')">{{ errors.first('recipient') }}</div>
                        </div>

                        <div class="primary-input-container text-area mt-3">
                            <p class="pimary-input-title">message</p>
                            <div data-v-8e398240="" class="text-area-container">
                                <textarea v-model="text" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('text')}" name="text" placeholder="Enter message content" maxlength="160" cols="30" rows="10"></textarea>

                            </div>
                            <div class="help is-danger" v-if="errors.has('text')">{{ errors.first('text') }}</div>
                        </div>

                        <div class="primary-button mt-4">
                            <primary-button :disabled="loading" @click.native="sendSms()">Submit <clip-loader style="width: 25px;" class="d-inline-block" v-if="loading" :loading="loading" color="#77bcff" size="16px"></clip-loader></primary-button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import TextArea from "../../../components/Inputs/TextArea";
    export default {
        name: "Index",
        components: {
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            AppDropzone: () => import("@/components/Dropzone"),
            ClipLoader,
            TextArea
        },
        data(){
            return {
                dnis_list: [],
                dnis: null,
                company_list: [],
                company: null,
                text: null,
                loading: false,
                checked: null,
                bulk_text: null,
                fileinput: "",
                uploadNumbers: [],
                newNumberList: []
            }
        },
        methods: {
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.createInput(files[0]);
            },
            createInput(file) {
                let promise = new Promise((resolve, reject) => {
                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = e => {
                        resolve((vm.fileinput = reader.result));
                        this.uploadNumbers = reader.result.split("\n")
                    };
                    reader.readAsText(file);
                });

                promise.then(
                    result => {
                        /* handle a successful result */
                        // console.log(this.fileinput);
                    },
                    error => {
                        /* handle an error */
                        console.log(error);
                    }
                );
            },
            async getCompanyList() {
                let data = {};
                const response = await this.$store.dispatch('GetAllDidsAni', data)
                this.company_list = response.items;
            },
            async getDnisList() {
                const response = await this.$store.dispatch('GetRecipientListSmsCenter');
                this.dnis_list = response.items;
            },
            async sendSms() {
                const valid = await this.$validator.validate();
                if(!valid) return;
                this.loading = true;
                let data = {
                    text: this.text,
                    dnis: this.dnis,
                    ani: this.company,
                };

                if(!this.company){
                    delete data.ani;
                }

                let numbers = this.bulk_text ? this.bulk_text.split('\n').concat(this.uploadNumbers).filter(Boolean) : (this.uploadNumbers).filter(Boolean)
                numbers.filter(number=> {
                    if (typeof number == 'number'){
                        return number
                    }
                });
                this.newNumberList = numbers
                if(this.checked){
                    data = {
                        text: this.text,
                        destinations: this.newNumberList,
                        checked: this.checked,
                        type: this.bulk_text ? 'bulk' : 'import'
                    };
                }

                const response = await this.$store.dispatch('SendSmsWorkflow', data);
                console.log(response);
                if(response.data && response.data.success){
                    this.text = null;
                    this.dnis = null;
                    this.company = null;
                    this.bulk_text = null;
                    this.uploadNumbers = [];
                    this.newNumberList = [];
                    this.checked = false;
                    this.$validator.reset();
                    this.$success('Success');
                }else if (response.response.data){
                    if(response.response.data.error.hasOwnProperty('message')){
                        try {
                            let messages = eval(response.response.data.error.message);
                            messages.map(message => {
                                this.$snotify.error(message);
                            })
                        } catch (e) {
                            this.$snotify.error(response.response.data.error.message);
                        }

                    }

                }
                this.loading = false;
            }
        },
        created() {
            this.getCompanyList();
            this.getDnisList();
        },
    }
</script>

<style scoped>
    .help {
        margin-top: 0px;
    }
    .primary-button {
        height: 40px;
        width: 135px;
    }
    input::-webkit-calendar-picker-indicator {
        display: none;
    }
    .datalist-img {
        position: absolute;
        left: 100%;
        top: 25px;
        margin-left: -35px;
    }
    .primary-select-wrapper .icon-down {
        position: absolute;
        left: 100%;
        margin-left: -35px;
    }
    .primary-select-wrapper select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        width: 100%;
        height: 100%;
        padding-left: 15px;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
    }
    .weekdays-from {
        margin-bottom: 15px;
    }
    .primary-select-wrapper {
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        border: 1px solid #edeef3;
        border-radius: 4px;
        background-color: #ffffff;
    }
    .primary-input-container .text-area-container {
        position: relative;
        height: calc(100% - 20px);
        width: 100%;
    }
    .primary-input-container .pimary-input-title {
        color: #000000;
        font-family: ""Helvetica Neue"";
        font-size: 12px;
        font-weight: 300;
        letter-spacing: 0.21px;
        line-height: 15px;
        margin-bottom: 5px;
        text-transform: uppercase;
    }
    .text-area {
        height: 120px;
        margin-bottom: 5px;
    }
    .primary-input-container .text-area-container textarea{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 10px 10px 10px 15px;
        border: 1px solid #edeef3;
        border-radius: 4px;
        outline: none;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        resize: none;
    }
    .primary-input-container .pimary-input {
        width: 100%;
        height: 40px;
        border: 1px solid #edeef3;
        border-radius: 4px;
        background-color: #ffffff;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        padding-left: 15px;
    }
</style>

<style lang="scss" scoped>
    .container {
        font-family: "Helvetica Neue";
        padding: 0 20px;

        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

            .back-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                fill: #51a3f3;
                color: #51a3f3;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;

                p {
                    margin-bottom: 0;
                }
            }

            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;

                .primary-button {
                    height: 40px;
                    width: 110px;
                }

                .secondary-button {
                    height: 40px;
                    width: 90px;
                    margin-right: 20px;
                }
            }
        }

        .add-container {
            flex-direction: column;
            align-items: center;
            height: auto;
            background-color: #ffffff;
            padding-top: 15px;

            .container-title {
                height: 30px;
                width: 432px;
                color: #000000;
                font-size: 18px;
                font-weight: 500;
                line-height: 30px;
                padding: 15px 0 15px 15px;
            }

            .col-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-left: 15px;
                margin-top: 20px;

                .col {
                    width: 100%;
                    margin-right: 15px;
                    padding-left: 0;

                    .input {
                        /*margin-bottom: 20px;*/
                    }

                    .field {
                        p.pimary-input-title {
                            color: #000000;
                            font-family: "Helvetica Neue";
                            font-size: 12px;
                            font-weight: 900;
                        }
                    }

                    .upload-photo,
                    #dropzone {
                        min-height: 285px;
                        min-height: 285px;
                        border-radius: 4px;
                        width: 100%;

                        .dz-image {
                            padding: 5px;

                            img {
                                height: 150px;
                                width: 150px;
                                border-radius: 50px;
                            }
                        }
                    }

                   p.pimary-input-title {
                            color: #000000;
                            font-family: "Helvetica Neue";
                            font-size: 12px;
                            font-weight: 900;
                        }

                    .upload-contaioner {
                        border: 1px solid #5171f3;
                        border-radius: 4px;
                        background-color: #ffffff;
                        height: 265px;
                        border-style: dashed;
                        margin-right: 15px;
                        position: relative;

                        input[type="file"] {
                            position: absolute;
                            height: 36px;
                            width: 136px;
                            opacity: 0;
                            cursor: pointer;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
                            z-index: 1;
                        }

                        .upload-button {
                            height: 36px;
                            width: 136px;
                            border-radius: 4px;
                            background-color: #51a3f3;
                            margin: 0;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }

            .email-input {
                margin-bottom: 20px;
            }

            .password-input {
                margin-bottom: 30px;
            }

            .first {
                margin-bottom: 30px;

                .remember-me {
                    display: flex;
                    align-items: center;

                    input {
                        margin-right: 5px;
                    }
                }
            }
        }
    }
</style>
